import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A6PortfoliosEdit } from "./edit";
import { A6PortfoliosNew } from "./new";
import { A6PortfoliosTable } from "./table";
export default function A6Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A6PortfoliosEdit />} />
      <Route index element={<A6PortfoliosTable />} />
      <Route path="/new" element={<A6PortfoliosNew />} />
    </Routes>
  );
}
